import React, { useState } from "react";
import { SelectionCheckbox } from "./SelectionCheckbox";
import style from "./SelectionBox.module.scss";
import { ExpandableContainer } from "../Misc/ExpandableContainer";

interface Props<T> {
  items: T[];
  getLabel: (item: T) => React.ReactNode;
  checked: (item: T) => boolean;
  onClick: (item: T) => void;
  itemKey: (item: T) => string | number;
  hiddenItems?: T[];
}

export function SelectionBox<T>({
  items,
  getLabel,
  checked,
  onClick,
  itemKey,
  hiddenItems,
}: Props<T>) {
  const [showHiddenItems, setShowHiddenItems] = useState(() => {
    if (!hiddenItems) return false;
    return hiddenItems.some((item) => checked(item));
  });

  return <div className={style.selectionBox}>
    {items.map((item) => (
      <SelectionCheckbox
        key={itemKey(item)}
        label={getLabel(item)}
        checked={checked(item)}
        onClick={() => onClick(item)}
      />
    ))}

    {hiddenItems && hiddenItems?.length > 0 && (
      <>
        <div className={style.divider} onClick={() => setShowHiddenItems(!showHiddenItems)}>
          <hr />
          <span className={style.dividerText}>
            {showHiddenItems ? "Hide removed nodes" : "Show removed nodes"}
          </span>
          <hr />
          <span>
            {showHiddenItems ? (
              <i className="fa-solid fa-chevron-up"></i>
            ) : (
              <i className="fa-solid fa-chevron-down"></i>
            )}
          </span>
        </div>
        <div style={{ gridColumn: "1 / -1" }} >
          <ExpandableContainer show={showHiddenItems}   >
            <div className={style.hiddenItems}>
              {hiddenItems.map((item) => (
                <SelectionCheckbox
                  key={itemKey(item)}
                  label={getLabel(item)}
                  checked={checked(item)}
                  onClick={() => onClick(item)}
                />
              ))}
            </div>
          </ExpandableContainer>
        </div>
      </>
    )}
  </div>
}
